import { epicRequest, reducersMerge, reduxFetchCreator, serverResponse } from 'app'

import type { InstitutionSchema } from '../schemas'

const update = reduxFetchCreator('institutionUpdate', serverResponse<InstitutionSchema>())

const institutionUpdateEpic = epicRequest({
  actionType: update.actions.institutionUpdate.type,
  debounce: 1000,
  errorAction: update.actions.institutionUpdateError,
  fulfilledAction: update.actions.institutionUpdateFulfilled,
  request: ({
    payload,
  }: {
    payload: {
      _avatar?: boolean
      avatar?: Blob
    } & Pick<InstitutionSchema, 'address' | 'blurb' | 'email' | 'id' | 'name' | 'nickname' | 'phone' | 'web'>
  }) => {
    const formData = new FormData()
    if (payload.avatar) {
      formData.append('avatar', payload.avatar)
    } else if (payload._avatar) {
      formData.append('_avatar', '1')
    }
    formData.append('name', payload.name)
    formData.append('nickname', payload.nickname)
    formData.append('address', payload.address)
    if (payload.blurb) {
      formData.append('blurb', payload.blurb)
    }
    formData.append('email', payload.email)
    formData.append('name', payload.name)
    formData.append('nickname', payload.nickname)
    formData.append('phone', payload.phone)
    if (payload.web) {
      formData.append('web', payload.web)
    }
    formData.append('_method', 'PUT')

    return {
      body: formData,
      method: 'post',
      url: `institution/${payload.id}`,
    }
  },
  untilTypes: update.actions.institutionUpdateCancel.type,
})

export const actions = {
  ...update.actions,
}

export const epics = [institutionUpdateEpic]

export const reducer = reducersMerge(update.reducer) as typeof update.reducer
